import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { Badge } from '@prisjakt/ui/badge';
import { ViewSize } from '../../types';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1 0 auto;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${layout.measurements.spacing025};
  align-items: center;
`;

export const CenteredFlexBox = styled.div`
  display: flex;
  align-items: center;
`;

export const FirstRow = styled(Row)`
  gap: ${layout.measurements.spacing050};
`;

const ICON_SIZE_PRICE_INFO = 24;
const ICON_SIZE_STOCK_STATUS_MOBILE = 20;

export const PriceInfoElement = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing025};

  svg {
    width: ${ICON_SIZE_PRICE_INFO}px;
    height: ${ICON_SIZE_PRICE_INFO}px;
  }
`;

interface IStockStatusWrapper {
  $viewSize?: ViewSize;
}

export const StockStatusWrapper = styled(PriceInfoElement)<IStockStatusWrapper>(
  props =>
    props.$viewSize === ViewSize.SMALL &&
    css`
      svg {
        width: ${ICON_SIZE_STOCK_STATUS_MOBILE}px;
        height: ${ICON_SIZE_STOCK_STATUS_MOBILE}px;
      }
    `
);

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledCaptionText = styled(CaptionText)`
  line-height: 1.25;
`;

type SustainabilityBadgeProps = {
  $addExtraSpacing?: boolean;
};

export const StyledSustainabilityBadge = styled(
  Badge
)<SustainabilityBadgeProps>(
  props => css`
    margin: ${props.$addExtraSpacing ? '2px' : '0'};
  `
);
